angular.module('aprima-core-ui').component('apAppointmentBrief', {
    bindings: {
        appointment: '<',
        showDuration: '<?'
    },
    templateUrl: '/core-ui/views/directives/partials/apAppointmentBrief.html',
    controller: ['DateUtilities', function(DateUtilities) {
        'use strict';

        // this logic is in $onInit instead of $onChanges because it's currently used with one-time bindings
        this.$onInit = function init() {
            if(this.appointment && this.appointment.AppointmentType && !this.appointment.AppointmentType.Name) {
                this.appointment.AppointmentType.Name = this.appointment.AppointmentType.Description;
            }
            this.getDuration = DateUtilities.getDurationString;
        };
    }]
});